/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Product_LoadingInputs */

const vi_pos_product_loading = /** @type {(inputs: Pos_Product_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải sản phẩm...`)
};

/**

* @param {Pos_Product_LoadingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_product_loading = /** @type {((inputs?: Pos_Product_LoadingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Product_LoadingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_product_loading(inputs)
});